import React, { useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  registerables as registerablesJS,
} from 'chart.js';
import { Color, ChartDataSet } from '../../types/app/chart.types';
import { Chart } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
import ResizableBox from '../../components/app/ResizableBox/ResizableBox';
import { Grid } from '@mui/material';
import { ThemeType } from '../../hooks/useLocalTheme';
import { GRAY } from '../../utils/core/functions/colors.function';

ChartJS.register(...registerablesJS);
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
);

interface Props {
  chartData: ChartDataSet[];
  labels: string[];
  displayLegend?: boolean;
  chartTitle?: string;
  localTheme?: ThemeType;
}

export function ChartsStateContainer({
  chartData,
  labels,
  displayLegend = true,
  chartTitle,
  localTheme,
}: Props) {
  const preparedData = {
    labels,
    datasets: chartData.map((dataset: ChartDataSet) => {
      return {
        type: dataset.chartType as any,
        label: dataset.label,
        backgroundColor: dataset.colors.map(
          (color: Color) => 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')',
        ),
        borderColor: dataset.style.borderColor,
        borderWidth: dataset.style.borderWidth,
        stepped: true,
        spanGaps: true,
        data: dataset.y.map((item: any) => item),
      };
    }),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          autoSkip: true,
        },
        type: 'time',
        distribution: 'linear',
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
        time: {
          displayFormats: {
            millisecond: 'HH:mm:ss',
            second: 'HH:mm:ss',
            minute: 'HH:mm:ss',
            hour: 'HH:mm:ss',
            day: 'HH:mm:ss',
            week: 'HH:mm:ss',
            month: 'HH:mm:ss',
            quarter: 'HH:mm:ss',
            year: 'HH:mm:ss',
          },
          tooltipFormat: 'HH:mm:ss.SSS',
        },
      },
      y: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
    },
    options: {
      animation: false,
    },
    plugins: {
      legend: {
        display: displayLegend,
      },
      title: {
        display: true,
        text: chartTitle ? chartTitle : '',
      },
    },
  };

  return (
    <>
      <ResizableBox height={300} width={visualViewport && visualViewport.width * 0.84}>
        <Chart type="line" data={preparedData} options={options} />
      </ResizableBox>
    </>
  );
}
